import React from 'react';
import ItemWrap from "../components/item-wrap";
import tipPng from './assets/tip.png';
import ctrl_left from './assets/ctrl_left.png';
import left from './assets/left.png';
import right from './assets/right.png';
import classnames from 'classnames';

const prefix = 'cs-map-tools-tip';

const Content = () => {
    const list = [
        {img: ctrl_left, text: '旋转', title: 'ctrl键+鼠标左键'},
        {img: left, text: '拖动视角', title: '鼠标左键'},
        {img: right, text: '平移视角', title: '鼠标右键'},
    ]
    return (
        <div className={classnames(prefix)}>
            <div className={classnames(`${prefix}-title`)}>操作提示</div>
            {list.map((item, index) => (
                <div
                    className={classnames(`${prefix}-item`)}
                    key={index}
                >
                    <div>
                        <img src={item.img} alt=""/>
                        <span className={classnames(`${prefix}-item-text`)}>{item.text}</span>
                    </div>

                    <div className={classnames(`${prefix}-item-title`)}>{item.title}</div>
                </div>
            ))}
        </div>
    )
}
const Tip = (props) => {
    const {show} = props;

    if (show) {
        return (
            <ItemWrap content={<Content />}>
                <img title="操作提示" src={tipPng} alt="" style={{width: '50%', height: '50%'}}/>
            </ItemWrap>
        )
    }

    return <></>
}

export default Tip;
